/**
 * CourseOptionRow - Radio de un curso origen en el paso 1 del wizard
 * "Copiar módulo". Toda la tarjeta va dentro del `label` del radio para que la
 * fila entera sea clicable y su texto forme el nombre accesible del control.
 */

import type { CopySourceCourse } from 'app/types/modules';
import React from 'react';
import AssetImage from '../../../../../atoms/AssetImage/AssetImage';
import InputRadio from '../../../../../atoms/InputRadio/InputRadio';

type CourseOptionRowProps = {
  course: CopySourceCourse;
  isSelected: boolean;
  name: string;
  onSelect: (courseGuid: string) => void;
  /** Solo en la pestaña «Programas»: allí el grupo no lo aporta la sección. */
  shouldShowGroup: boolean;
};

function CourseOptionRow({ course, isSelected, name, onSelect, shouldShowGroup }: CourseOptionRowProps): JSX.Element {
  function handleChange(): void {
    onSelect(course.guid);
  }

  const label = (
    <span className="copy-module-dialog__option">
      <span className="copy-module-dialog__option-image">
        <AssetImage alt="" id="noPictureProgram" src={course.picture} />
      </span>
      <span className="copy-module-dialog__option-texts">
        <span className="copy-module-dialog__option-name">
          {course.name}
          {shouldShowGroup && course.school_group_name && (
            <span className="copy-module-dialog__option-group">{` | ${course.school_group_name}`}</span>
          )}
        </span>
      </span>
    </span>
  );

  return <InputRadio checked={isSelected} label={label} name={name} onChange={handleChange} value={course.guid} variant="check" />;
}

export default CourseOptionRow;
